// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1qvOx","resendInfoText":"OnGoingPaymentBox_resendInfoText__W3Kjg"};